import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { ReportIncomeEventType } from './../report-income.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { ReportIncomeModel } from './../models/report-income';
import { Auth } from './../../../autentication/Auth';

@Component({
	selector: 'app-report-income-result',
	templateUrl: './report-income-result.component.html',
	styleUrls: ['./report-income-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ReportIncomeResultComponent implements OnInit, OnDestroy {

	@Input() reportIncomeData: ReportIncomeModel;
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="report-income-result"]';
	public active = false;
	public showExportButtons = true;
	public pdfName: string;

	constructor() {}

	ngOnInit() {
		AppEventDispatcher.listen(ReportIncomeEventType.STEPS.REPORT_INCOME_RESULT, data => {
			if (data.show) {
				this.active = true;
				this.show();

				this.showStepButtons.emit(true);
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ReportIncomeEventType.STEPS.REPORT_INCOME_RESULT);
	}

	show() {
		const title = 'Resultado do informe de rendimentos';

		this.setTitle.emit({
			title: title
		});

		this.pdfName = 'InformeRendimentos_' + Auth.getInstance().getUser().cpfCnpj;

		AppEventDispatcher.dispatch(ReportIncomeEventType.BUTTONS, { show: true, activeBackButton: true });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});

			AppEventDispatcher.dispatch(EventTypes.EXPORT_BUTTONS.DATA_REPORT_INCOME, {
				yearReportIncome: this.reportIncomeData.year,
			});

		});
	}

	hide() {
		TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 40;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income-result/report-income-result.component.ts